import React, { useEffect, useState } from "react";
import { toast } from "sonner";

/** Reconnect-detection: offline-banner + online-toast. Geen offline-first (pilot 1). */
export function OnlineBanner() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  useEffect(() => {
    function onOn() { setOnline(true); toast.success("Verbinding hersteld"); }
    function onOff() { setOnline(false); }
    window.addEventListener("online", onOn);
    window.addEventListener("offline", onOff);
    return () => {
      window.removeEventListener("online", onOn);
      window.removeEventListener("offline", onOff);
    };
  }, []);
  if (online) return null;
  return (
    <div role="status" aria-live="polite" data-testid="offline-banner"
      className="sticky top-0 z-40 w-full bg-amber-500 px-4 py-2 text-center text-sm font-medium text-white shadow">
      Geen verbinding — invoer wordt lokaal bewaard
    </div>
  );
}
